import { render, staticRenderFns } from "./SetPaperStepTwoJudge.vue?vue&type=template&id=25920b80&scoped=true&"
import script from "./SetPaperStepTwoJudge.vue?vue&type=script&lang=js&"
export * from "./SetPaperStepTwoJudge.vue?vue&type=script&lang=js&"
import style0 from "./SetPaperStepTwoJudge.vue?vue&type=style&index=0&id=25920b80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25920b80",
  null
  
)

export default component.exports